import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
import styles from './error-toast.module.scss';
import { CatIconWarningDiamondFilled } from 'components/blocks-components';
import { ErrorToastProps } from '../../../types';

export default async function ErrorToast({
  children
}: Readonly<ErrorToastProps>) {
  return (
    <div className={styles['toast-message_allignment']}>
      <CatToastGroup verticalPosition="top" horizontalPosition="center">
        <CatToast variant="error">
          <div className="d-flex">
            <CatIconWarningDiamondFilled
              className="pe-2"
              slot="before"
              color="error"
            />
            {children}
          </div>
        </CatToast>
      </CatToastGroup>
    </div>
  );
}
